import { render, staticRenderFns } from "./NotificationRow.vue?vue&type=template&id=47852b30&"
import script from "./NotificationRow.vue?vue&type=script&lang=js&"
export * from "./NotificationRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NotificationRow.vue"
export default component.exports